import { REQUEST_STATUS_COMPLETED } from '../../../../../share/util/api/polling';
import apiService from '../../../../../share/util/api/service';
import WS45Dialog from '../Requirement045Dialog';
import requirement045Utils from './Requirement045Utils';

/**
 * [diag] レディネスコード判定
 * @param {instance} self 呼び出し元this
 */
export async function judgeReadinessCode(self) {
  try {
    self.isLoading = true;
    const response = await requirement045Utils.doPolling(
      self,
      apiService.DIAG,
      { dtc: requirement045Utils.getAllTargetDtcList(self), is_called_from_work_support: true },
      `/netApps/${self.netAppId}/systems/${self.systemId}/readinessCodes`,
      `/netApps/${self.netAppId}/systems/${self.systemId}/requests/`,
      false
    );
    if (response && response.data.status === REQUEST_STATUS_COMPLETED) {
      // 正常終了 : [diag] レディネスコード判定結果取得処理
      self.measuredId = response.data.measured_id.toString(); // measured_idを保持
      await self.getReadinessCodeJudgeResult();
    } else {
      throw new Error('Unexpected error occurred');
    }
  } catch (error) {
    await requirement045Utils.exceptionHandler(requirement045Utils.METHODS.JUDGE_READINESS_CODE, error, self);
  } finally {
    requirement045Utils.terminationHandler(self);
  }
}

/**
 * [wsp] Read ドライブサイクルデータ取得
 * @param {instance} self 呼び出し元this
 */
export async function getReadinessCodeJudgeResult(self) {
  try {
    self.isLoading = true;
    const response = await requirement045Utils.doSyncRequest(
      self,
      apiService.DIAG,
      `/diagDtc/${self.projectId}/${self.measuredId}/readinessCode/${self.systemId}`
    );
    // 正常コールバック
    if (response) {
      self.dtcStatusAvailabilityMask
        = response.data.dtc_status_availability_mask.test_not_completed_this_operation_cycle;
      // 正常終了 : レディネスコード取得画面を表示
      self.dialog.phase = WS45Dialog.PHASE.GET_READINESS_CODE;
    } else {
      throw new Error('Unexpected error occurred');
    }
  } catch (error) {
    await requirement045Utils.exceptionHandler(requirement045Utils.METHODS.GET_READINESS_CODE_JUDGE_RESULT, error, self);
  } finally {
    requirement045Utils.terminationHandler(self);
  }
}

export default {
  judgeReadinessCode,
  getReadinessCodeJudgeResult
};